import React, { createContext, useContext, useState } from 'react';

const DroneDetailContext = createContext();

export function DroneDetailProvider({children}) {
  const [featuresData, setFeaturesData] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [deletedFeature, setDeletedFeature] = useState(null);
  const [selectedTool, setSelectedTool] = useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const { Provider } = DroneDetailContext;

  const contextData = {
    featuresData,
    setFeaturesData,
    selectedFeature,
    setSelectedFeature,
    deletedFeature,
    setDeletedFeature,
    selectedTool,
    setSelectedTool,
    unsavedChanges,
    setUnsavedChanges
  }

  return <Provider value={contextData}>{children}</Provider>;
}
export const useDroneDetailContext = () => useContext(DroneDetailContext);